import { GoogleGenAI, Chat } from "@google/genai";

const apiKey = process.env.API_KEY || '';

let aiClient: GoogleGenAI | null = null;
let chatSession: Chat | null = null;

export const initializeGemini = () => {
  if (!apiKey) {
    console.warn("API Key not found for Gemini.");
    return;
  }
  if (!aiClient) {
    aiClient = new GoogleGenAI({ apiKey });
  }
};

export const getChatSession = (): Chat => {
  if (!aiClient) initializeGemini();
  
  if (!chatSession && aiClient) {
    chatSession = aiClient.chats.create({
      model: 'gemini-3-flash-preview',
      config: {
        systemInstruction: `You are 'BancoBot', a highly intelligent, secure, and friendly AI banking assistant for BancoWEB. 
        BancoWEB is a fintech platform for merchants (similar to Wise and PayPal).
        Your tone should be professional yet approachable, concise, and helpful.
        You can help with:
        - Analyzing spending trends (simulate this).
        - Explaining currency exchange rates.
        - Advice on merchant invoicing.
        - Navigating the app.
        
        If asked about real-time account data, politely explain that for security in this demo, you are using simulated context, but in a real app, you would have secure access.
        Keep responses under 100 words unless detailed financial advice is requested.`,
      },
    });
  }
  
  if (!chatSession) {
      throw new Error("Failed to initialize Gemini Chat session");
  }

  return chatSession;
};

export const sendMessageToGemini = async (message: string): Promise<string> => {
    try {
        const chat = getChatSession();
        const response = await chat.sendMessage({ message });
        return response.text || "I apologize, I couldn't process that request.";
    } catch (error) {
        console.error("Gemini Error:", error);
        return "I'm currently having trouble connecting to the banking network. Please try again later.";
    }
};